import React from 'react'

import { CardTemplate } from '../../../../components/CardTemplate'
import { PanelContainer } from '../../../../components/Panel'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { useConfigContext } from '../../../ui-config/context'
import { useOrder } from '../../data'

type Props = {
  id: string
}

export const Header: React.FC<Props> = ({ id }) => {
  const { uiConfig: config } = useConfigContext()
  const { data: order, isLoading } = useOrder(id)

  return (
    <PanelContainer
      header={getConfigTranslation(config.orderResponse.header.title)}
      id="order-header"
      visible={config.orderResponse.header.enabled}
    >
      <div className="grid">
        {/* Buyer */}
        <CardTemplate
          title={getConfigTranslation(
            config.orderResponse.header.buyerInformation?.title,
          )}
          data={order?.Payload.BuyerInformation}
          config={config.orderResponse.header.buyerInformation}
          isLoading={isLoading}
        />

        {/* Seller */}
        <CardTemplate
          title={getConfigTranslation(
            config.orderResponse.header.sellerInformation?.title,
          )}
          data={order?.Payload.SellerInformation}
          config={config.orderResponse.header.sellerInformation}
          isLoading={isLoading}
        />

        {/* Billing */}
        <CardTemplate
          title={getConfigTranslation(
            config.orderResponse.header.billingInformation?.title,
          )}
          data={order?.Payload.BillingInformation}
          config={config.orderResponse.header.billingInformation}
          isLoading={isLoading}
        />

        {/* Shipping */}
        <CardTemplate
          title={getConfigTranslation(
            config.orderResponse.header.shippingInformation?.title,
          )}
          data={order?.Payload.ShippingInformation}
          config={config.orderResponse.header.shippingInformation}
          isLoading={isLoading}
        />
      </div>
    </PanelContainer>
  )
}
